// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"styles_tableBody__MIUUx","actions":"styles_actions__mlKWV","compactTable":"styles_compactTable__P_luE"};